/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  SvgIcon,
  Button
} from '../'

export class ExpandableSection extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    summary: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    children: PropTypes.any,
    open: PropTypes.bool,
    locked: PropTypes.bool,
    expandIconOnLeft: PropTypes.bool,
    inline: PropTypes.bool,
    buttonId: PropTypes.string,
    onClick: PropTypes.func,
    titleWidthClassName: PropTypes.string,
    className: PropTypes.string
  }

  static defaultProps = {
    open: false,
    locked: false,
    expandIconOnLeft: false,
    inline: true,
    buttonId: 'expand',
    titleWidthClassName: '',
    className: ''
  }

  render() {
    const displayStyle = this.props.open ? 'block' : 'none'
    const { title, children, open, locked, summary, expandIconOnLeft, inline, onClick, titleWidthClassName, className } = this.props

    return (
      <div className={`slds-section${open ? ' slds-is-open' : ''} ${className}`}>
        <h3 className='slds-section__title'>
          <Button
            type='reset'
            className='expandable-selection-button'
            onClick={locked ? () => false : onClick}>
            {expandIconOnLeft &&
              <SvgIcon
                variant='utility'
                symbol={open ? 'chevronup' : 'chevrondown'}
                size='x-small'
                colour={locked ? 'light' : 'default'}d
                className='slds-p-right_small'
              />
            }
            <span className='slds-size_1-of-1'>
              {!open
                ? <div className={`${inline ? 'slds-grid slds-gutters_xx-large' : ''}`}>
                    <div className={titleWidthClassName || 'slds-small-size_1_of_2 slds-medium-size_5-of-12 slds-large-size_1-of-4'}>
                      {title}
                    </div>
                    {summary &&
                      <div className={`slds-text-body_small slds-text-color_weak slds-p-right_large slds-truncate ${titleWidthClassName ? '' : 'slds-small-size_1_of_2 slds-medium-size_7-of-12 slds-large-size_3-of-4'}`}>
                        {summary}
                      </div>
                    }
                  </div>
                : typeof title === 'string'
                  ? <span className='u-font-size-x-large'>{title}</span>
                  : title
              }
            </span>
            {!expandIconOnLeft &&
              <SvgIcon
                variant='utility'
                symbol={open ? 'chevronup' : 'chevrondown'}
                size='x-small'
                colour={locked ? 'light' : 'default'}
              />
            }
          </Button>
        </h3>
        {!locked &&
          <div aria-hidden={!open} className='slds-section__content' style={{ display: displayStyle }}>
            {children}
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/expandable-section/index.js